document.addEventListener("DOMContentLoaded", function () {
  // Time delay in milliseconds (e.g., 10 seconds = 10000)
  const delay = 10000;

  // Select all product links (adjust the selector based on your theme)
  const productLinks = document.querySelectorAll('a[href*="/products/"]');

  // Function to show the bubble
  function showBubble() {
    const bubble = document.getElementById("custom-bubble");
    if (bubble) {
      bubble.style.display = "block";
      // Automatically hide the bubble after 5 seconds
      setTimeout(() => {
        bubble.style.display = "none";
      }, 5000); // Adjust the display duration as needed
    }
  }

  // Add click event listeners to product links
  productLinks.forEach((link) => {
    link.addEventListener("click", function () {
      // Set a timeout to show the bubble after the delay
      setTimeout(showBubble, delay);
    });
  });
});